import React, { useCallback, useEffect, useState } from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import styled from "styled-components";
import About from "../components/About";
import VideoPC from "../assets/images/hyper-pc.mp4";
import VideoMobile from "../assets/images/hyper-mobile.mp4";
import Mission from "../components/Mission";
import Portfolio from "../components/Portfolio";
import Team from "../components/Team";
import Partners from "../components/Partners";
import Contact from "../components/Contact";

import { useMyMediaQuery } from "../hooks/useMediaQuery";
import { device } from "../styles/media-query";
import { throttle } from "lodash";
// import { animated, useSpring } from "react-spring";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  background: black;
  width: 100%;
  overflow: hidden;
`;

// ${({ visible }) =>
//   visible &&
//   css`
//     width: 0;
//     height: 0;
//     top: -30000px;
//     left: -30000px;
//     border-radius: 50%;
//     opacity: 0;
//   `};
//
// const LoadingContainer = styled(animated.div)<{ visible: boolean }>`
//   //transition: all 800ms ease-out;
//   width: 100vw;
//   height: 100vh;
//   left: 0;
//   right: 0;
//   top: 0;
//   background: #000;
//   opacity: 1;
//   z-index: 10;
//   position: fixed;
// `;

enum CurrentSection {
  Home,
  ABOUT,
  MISSION,
  PORTFOLIO,
  TEAM,
  PARTNERS,
}

function getOffsetTop(id: string) {
  return document?.getElementById(id)?.offsetTop ?? 0;
}

const ParallaxBanner = styled.div`
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
`;

const BannerVideo = styled.video`
  position: absolute;
  box-sizing: border-box;
  min-width: 100%;

  width: 100vh;

  ${device.desktop} {
    transform: translate(-50%, 40%);
    top: 40%;
    left: 50%;
    height: 100vh;
    object-fit: cover;
  }

  transform: translate(-50%, 80%);
  top: 80%;

  left: 50%;
`;

function Home() {
  const [show, setShow] = useState(false);
  const { isDesktop } = useMyMediaQuery();
  const [movingByHeaderMenu, setMovingByHeaderMenu] = useState(false);
  const [currentSection, setCurrentSection] = React.useState(
    CurrentSection.Home
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    const video = document.getElementById("video") as HTMLVideoElement;
    if (video) {
      video.addEventListener("canplay", () => {
        setTimeout(() => {
          setShow(true);
        }, 300);
      });
    }
  }, []);

  const handleScroll = useCallback(() => {
    if (movingByHeaderMenu) return;

    const scroll = window.scrollY;

    const aboutTop = getOffsetTop("about");
    const missionTop = getOffsetTop("mission");
    const portfolioTop = getOffsetTop("portfolio");
    const teamTop = getOffsetTop("team");
    const partnersTop = getOffsetTop("partners");

    if (scroll) {
      if (scroll > aboutTop && scroll < missionTop) {
        setCurrentSection(CurrentSection.ABOUT);
      } else if (scroll >= missionTop && scroll < portfolioTop) {
        setCurrentSection(CurrentSection.MISSION);
      } else if (scroll >= portfolioTop && scroll < teamTop) {
        setCurrentSection(CurrentSection.PORTFOLIO);
      } else if (scroll >= teamTop && scroll < partnersTop) {
        setCurrentSection(CurrentSection.TEAM);
      } else if (scroll >= partnersTop) {
        setCurrentSection(CurrentSection.PARTNERS);
      } else {
        setCurrentSection(CurrentSection.Home);
      }
    }
  }, [movingByHeaderMenu]);

  const onScroll = throttle(handleScroll, 200);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [onScroll]);

  const goToSection = (section: CurrentSection) => {
    setMovingByHeaderMenu(true);
    let top = 0;
    switch (section) {
      case CurrentSection.Home:
        top = 0;
        break;
      case CurrentSection.ABOUT:
        top = getOffsetTop("about");
        break;
      case CurrentSection.MISSION:
        top = getOffsetTop("mission");
        break;
      case CurrentSection.PORTFOLIO:
        top = getOffsetTop("portfolio");
        break;
      case CurrentSection.TEAM:
        top = getOffsetTop("team");
        break;
      case CurrentSection.PARTNERS:
        top = getOffsetTop("partners");
    }

    window.scroll({
      top: top + (isDesktop ? 100 : 0),
      behavior: "smooth",
    });

    setTimeout(() => {
      setMovingByHeaderMenu(false);
    }, 1000);
  };

  return (
    <div style={{ background: "black", width: "100%", minHeight: "100vh" }}>
      {/*<LoadingContainer visible={show} style={loadingContainerStyle} />*/}

      <Container style={{ visibility: show ? "visible" : "hidden" }}>
        <Header
          currentSection={currentSection}
          onClickMenu={(sectionIndex) => {
            setCurrentSection(sectionIndex);
            goToSection(sectionIndex);
          }}
          drawerOpen={isDrawerOpen}
          onClickDrawer={() => setIsDrawerOpen(!isDrawerOpen)}
        />

        <ParallaxBanner>
          <div style={{ position: "relative", width: "100%" }}>
            <BannerVideo
              src={isDesktop ? VideoPC : VideoMobile}
              loop
              playsInline
              autoPlay
              muted
              id={"video"}
            />
          </div>
        </ParallaxBanner>
        <Banner />
        <About />
        <div style={{ zIndex: 10, background: "black" }}>
          <Mission />
          <div style={{ background: "#1c1c1c" }}>
            <Portfolio />
          </div>
          <Team />
          <div style={{ background: "#1c1c1c" }}>
            <Partners />
          </div>
          <Contact />
        </div>
      </Container>
    </div>
  );
}

export default Home;
